import { render, staticRenderFns } from "./UserListTabModal.vue?vue&type=template&id=23dd8075&scoped=true&"
import script from "./UserListTabModal.vue?vue&type=script&lang=js&"
export * from "./UserListTabModal.vue?vue&type=script&lang=js&"
import style0 from "./UserListTabModal.vue?vue&type=style&index=0&id=23dd8075&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dd8075",
  null
  
)

export default component.exports